var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Outlet } from 'react-router-dom';
import { Box } from '@lucidlink/uicore';
import { useSetAmplitudeUser } from '@lucidlink/workspacemanagement';
import styles from './MobileMain.module.css';
export const MobileMain = () => {
    _react_refresh_temp_2();
    // External Integrations
    useSetAmplitudeUser();
    return (_jsxs(_Fragment, { children: [_jsx(Box, { className: styles.Container, "data-testid": "mobile-root-layout-container", orientation: "vertical", scrollableY: true, children: _jsx(Box, { "data-testid": "mobile-root-layout-outlet-container", isFullHeight: true, isFullWidth: true, children: _jsx(Outlet, {}) }) }), _jsx(ReactQueryDevtools, { buttonPosition: "bottom-left", initialIsOpen: false })] }));
};
_react_refresh_temp_1 = MobileMain;
$RefreshReg$(_react_refresh_temp_1, "MobileMain");
_react_refresh_temp_2(MobileMain, "h0DM9zrpbJB94jpnD9FZmKWgQWQ=", false, () => [
    // External Integrations
    useSetAmplitudeUser]);
